const BASE_URL = 'https://app.cardladder.com/sales-history?sort=date&direction=desc';
const QUALIFIERS = ['Reverse Holofoil', 'Reverse Holo', 'Reverse Foil', 'Gold Star', 'Delta Species', '1st Edition', 'Unlimited', 'Staff', 'Holofoil', 'Holo', 'Delta'];

function text(value) {
  if (typeof value !== 'string' && typeof value !== 'number') return '';
  return String(value).normalize('NFKC')
    .replace(/<(script|style)\b[^>]*>[\s\S]*?<\/\1>/gi, ' ')
    .replace(/<[^>]*>/g, ' ').replace(/[<>\u0000-\u001f\u007f]/g, ' ')
    .replace(/\b(?:first\s*edition|1st\s*edition)\b/gi, '1st Edition')
    .replace(/\bgold\s*star\b/gi, 'Gold Star')
    .replace(/\s+/g, ' ').trim().slice(0, 250);
}

function grade(value) {
  const candidate = text(value).replace(/^(?:(?:ACE|PSA|CGC|BGS)\s*)+/i, '');
  if (!/^\d{1,2}(?:\.\d)?$/.test(candidate)) return null;
  const number = Number(candidate);
  return number > 0 && number <= 10 ? String(number) : null;
}

const escapePattern = value => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
function withoutPhrase(value, phrase) {
  const pattern = escapePattern(phrase).replace(/\s+/g, '\\s+');
  return value.replace(new RegExp(`(^|[^\\p{L}\\p{N}])${pattern}(?=$|[^\\p{L}\\p{N}])`, 'giu'), '$1');
}

export function cardLadderSearchQuery(slab) {
  const sameGrade = grade(slab?.grade);
  const name = text(slab?.name).replace(/^(?:(?:PSA(?=\s|\d|$)\s*(?:\d+(?:\.\d+)?\b\s*)?|(?:ACE|CGC|BGS)\s*\d+(?:\.\d+)?\b\s*)[-:–—]?\s*)+/i, '').trim();
  if (!sameGrade || !name) return null;
  const parts = [name];
  for (const field of ['number', 'set', 'language', 'variant', 'edition', 'additionalInformation']) {
    let value = text(slab?.[field]);
    if (!value || /^(?:unknown|none|n\/?a|not recorded|-)$/i.test(value)) continue;
    if (field === 'language') {
      if (/^(?:English|EN|ENG)$/i.test(value)) continue;
      value = ({ JP: 'Japanese', JPN: 'Japanese', JA: 'Japanese' })[value.toUpperCase()] || value;
    }
    if (['variant', 'edition', 'additionalInformation'].includes(field)) {
      for (const term of ['English', 'EN', 'ENG']) value = withoutPhrase(value, term);
    }
    for (const previous of [...parts].sort((a, b) => b.length - a.length)) value = withoutPhrase(value, previous);
    const existing = parts.join(' ');
    for (const qualifier of QUALIFIERS) if (withoutPhrase(existing, qualifier) !== existing) value = withoutPhrase(value, qualifier);
    value = value.replace(/^[\s,;|/()[\]–—-]+|[\s,;|/()[\]–—-]+$/g, '').replace(/\s+/g, ' ').trim();
    if (value) parts.push(value);
  }
  return `PSA ${sameGrade} ${parts.join(' ')}`;
}

export function cardLadderSearchUrl(slab) {
  const query = cardLadderSearchQuery(slab);
  if (!query) return null;
  const url = new URL(BASE_URL);
  url.searchParams.set('q', query);
  return url.href;
}
